export function validateString(
  value: string | null | undefined
): string | null | undefined {
  return value && value.trim().length > 0
    ? undefined
    : "Please provide some text";
}
